import { Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface AddItemButtonProps {
  isProductQuote: boolean
  onAddRole: () => void
  onAddProduct: () => void
}

const AddItemButton = ({ isProductQuote, onAddRole, onAddProduct }: AddItemButtonProps) => {
  return isProductQuote ? (
    <Button type="secondary" iconName="add" onClick={onAddProduct}>
      {i18n.t('finance.quotes.quote_phases_table.actions.add_item')}
    </Button>
  ) : (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button type="secondary" iconName="add">
          {i18n.t('finance.quotes.quote_phases_table.actions.add_item')}
        </Button>
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="center">
        <PopoverMenu.TouchableOption
          title={i18n.t('finance.quotes.quote_phases_table.actions.add_role')}
          onClick={onAddRole}
        />
        <PopoverMenu.TouchableOption
          title={i18n.t('finance.quotes.quote_phases_table.actions.add_product')}
          onClick={onAddProduct}
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default AddItemButton
